import script from "./MultiSelectDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelectDropdown.vue?vue&type=style&index=0&id=b77c8c74&lang=css"

const __exports__ = script;

export default __exports__